import { AxiosPromise } from 'axios';
import axios from 'utils/axios';
import { ApiResponseEntity, LoginResponseDTO, LoginUserDTO } from 'types';

const API_PATH = "/auth";

export default class LoginApi {
    static login(data: LoginUserDTO): AxiosPromise<ApiResponseEntity<LoginResponseDTO>> {
        return axios.post(`${API_PATH}/login`, data);
    }
}